// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_FULL } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const likesHistoryConfig = {
    title: 'chart.twitter.likes_history',
    tooltip: 'chart.twitter.likes_history_tooltip',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.twitter.likes_history_name',
        avg: 'chart.twitter.likes_history_avg'
    },
    id: 'likes_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_FULL,
    type: 'chart',
    element: LineChart
};
